export enum ProductMetatDataValue {
    DISTRIBUTORELIGIBLE = 'DISTRIBUTORELIGIBLE',
    FREE_PRODUCT_ELIGIBLE = 'FREE_PRODUCT_ELIGIBLE',
    BEST_VALUES = 'BEST_VALUES',
    FEATURED_PAK = 'FEATURED_PAK'
}